import { deprecated } from "@gr-common/head/logger";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                 */
export function add<
  T extends HTMLElement,
  K extends keyof HTMLElementEventMap,
  F extends (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
>(obj: T, type: K, fn: F, useCapture = false): void {
  deprecated("event", "add", "use native addEventListener instead");
  obj.addEventListener(type, fn, useCapture);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function remove<
  T extends HTMLElement,
  K extends keyof HTMLElementEventMap,
  F extends (this: HTMLElement, ev: HTMLElementEventMap[K]) => void,
>(obj: T, type: K, fn: F): void {
  deprecated("event", "remove", "use native removeEventListener instead");
  obj.removeEventListener(type, fn, false);
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function stopPropagation<T extends Event>(event: T): void {
  deprecated("event", "stopPropagation", "use native event.stopPropagation instead");
  event.stopPropagation();
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getTarget<T extends Event>(event: T): EventTarget | null {
  deprecated("event", "getTarget", "use native event.target instead");
  return event.target;
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function preventDefault<T extends Event>(event: T): void {
  deprecated("event", "preventDefault", "use native event.preventDefault instead");
  event.preventDefault();
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function trigger<T extends Element>(element: T, type: string): void {
  deprecated("event", "trigger", "use native CustomElements instead");
  const event = document.createEvent("HTMLEvents");

  event.initEvent(type, true, true);
  element.dispatchEvent(event);
}
/*                */
